/**
 * Configuration Constants
 *
 * Contains configuration values for API endpoints, timeouts, and retries.
 */

/**
 * API Configuration
 */
export const API_CONFIG = {
  /**
   * Maximum number of retry attempts for polling verification status
   */
  MAX_POLL_ATTEMPTS: 60,

  /**
   * Interval between polling attempts in milliseconds
   */
  POLL_INTERVAL_MS: 1000,

  /**
   * Default API timeout in milliseconds
   */
  DEFAULT_TIMEOUT_MS: 30000,
} as const;

/** Face Verification pre-flight support check (VEX-7617). */
export const LIVENESS_PREFLIGHT = {
  /**
   * Which failing tests may block. Per-test, not one flag: the rest pass ~42% (VEX-7881).
   */
  ENFORCEABLE_TESTS: ["localStorage", "wasm"],
} as const;

/**
 * UI Configuration
 */
export const UI_CONFIG = {
  /**
   * Minimum height for iProov container
   */
  IPROOV_MIN_HEIGHT: 500,
} as const;
